import { isEmpty } from "lodash";
import { BaseIdOnly } from "../base";
import { DEFAULT_LANGUAGE } from "../language";
import { AirdropConfig } from "../nft";
import { PaymentConfig } from "../payment";
import { unique } from "../utils";
import { NFTEventTierMoonpassConstraint, } from "./constraint/moonpass";
import { NFTConstraint } from "./constraint/nft";
import { NFTEventTierEmailConfig } from "./email";
import { NFTEventTierUsageConstraint, } from "./usage";
import { NFTEventTierWhitelistConstraint, } from "./whitelist";
export class NFTEventTier extends BaseIdOnly {
    constructor(params) {
        var _a;
        super(params);
        this.order = (_a = params === null || params === void 0 ? void 0 : params.order) !== null && _a !== void 0 ? _a : 1;
        this.info = {};
        if ((params === null || params === void 0 ? void 0 : params.info) && !isEmpty(params === null || params === void 0 ? void 0 : params.info)) {
            this.info = params.info;
        }
        else {
            this.info[DEFAULT_LANGUAGE] = {
                name: (params === null || params === void 0 ? void 0 : params.name) || "",
                description: (params === null || params === void 0 ? void 0 : params.description) || "",
                rewards: (params === null || params === void 0 ? void 0 : params.rewards) || [],
                instruction: (params === null || params === void 0 ? void 0 : params.instruction) || "",
            };
        }
        // TODO remove
        this.name = (params === null || params === void 0 ? void 0 : params.name) || "";
        this.description = (params === null || params === void 0 ? void 0 : params.description) || "";
        this.rewards = (params === null || params === void 0 ? void 0 : params.rewards) || [];
        this.instruction = (params === null || params === void 0 ? void 0 : params.instruction) || "";
        // TODO remove
        this.imageUrl = (params === null || params === void 0 ? void 0 : params.imageUrl) || "";
        if ((params === null || params === void 0 ? void 0 : params.nftConstraint) && !isEmpty(params.nftConstraint.collections)) {
            this.nftConstraint = new NFTConstraint(params.nftConstraint);
            if (this.nftConstraint.collections.length == 0)
                delete this.nftConstraint;
        }
        if (params === null || params === void 0 ? void 0 : params.whitelistConstraint)
            this.whitelistConstraint = new NFTEventTierWhitelistConstraint(this.nftConstraint
                ? Object.assign(Object.assign({}, params.whitelistConstraint), { nftRequirement: Math.max(1, params.whitelistConstraint.nftRequirement || 0) }) : params.whitelistConstraint);
        if (params === null || params === void 0 ? void 0 : params.moonpassConstraint)
            this.moonpassConstraint = new NFTEventTierMoonpassConstraint(params.moonpassConstraint);
        this.usageConstraint = new NFTEventTierUsageConstraint(params === null || params === void 0 ? void 0 : params.usageConstraint);
        if (params === null || params === void 0 ? void 0 : params.paymentConfig)
            this.paymentConfig = new PaymentConfig(params.paymentConfig);
        if (params === null || params === void 0 ? void 0 : params.airdropConfig)
            this.airdropConfig = new AirdropConfig(params.airdropConfig);
        if (params === null || params === void 0 ? void 0 : params.attendanceAirdropConfig)
            this.attendanceAirdropConfig = new AirdropConfig(params.attendanceAirdropConfig);
        if (params === null || params === void 0 ? void 0 : params.emailConfig)
            this.emailConfig = new NFTEventTierEmailConfig(params.emailConfig);
    }
    filterEligibleNFTCollections(nfts) {
        const results = [];
        if (!this.nftConstraint)
            return [];
        for (const collection of this.nftConstraint.collections) {
            const _nfts = nfts.filter((n) => collection.validateNFT(n));
            const tokens = unique(_nfts.map((n) => n.tokenId));
            if (tokens.length == 0)
                return [];
            results.push({
                network: collection.network,
                collectionId: collection.collectionId,
                nfts: _nfts,
                tokens,
            });
        }
        return results;
    }
    getEligibleNFTCollectionCount(nfts) {
        const eligibleCollections = this.filterEligibleNFTCollections(nfts);
        if (eligibleCollections.length == 0)
            return 0;
        return Math.min(...eligibleCollections.map((e) => e.tokens.length));
    }
    validateNFTConstraint(nfts) {
        return this.filterEligibleNFTCollections(nfts).length > 0;
    }
    validateMoonpassConstraint(moonpass) {
        if (!this.moonpassConstraint)
            return true;
        if (!moonpass)
            return false;
        if (this.moonpassConstraint.edition == "all")
            return true;
        return this.moonpassConstraint.edition === moonpass.edition;
    }
}
